import '.a{display:flex;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import '.bb{font-size:0.875rem;}.ssr-plugin'
import '.bc{color:var(--gray-300);}.ssr-plugin'
import { Avatar, AvatarSize, AvatarShape } from '@app/components/core/avatar/Avatar'
import { styled } from 'inlines'

interface AuthorProps {
  avatarSrc?: string
  avatarSize?: AvatarSize
  avatarShape?: AvatarShape
  name: string
  description?: string
}

export const Author = ({
  avatarSrc,
  avatarSize = 'small',
  avatarShape = 'circle',
  name,
  description,
}: AuthorProps) => {
  return (
    <div className="a t u"
    >
      <Avatar size={avatarSize} image={avatarSrc} labelSource={name} shape={avatarShape} />

      <div>
        <styled.strong>{name}</styled.strong>
        <div className="bb bc"
        >
          {description}
        </div>
      </div>
    </div>
  )
}
